export var GENERIC_SEPARATOR = '#';